import React, { useCallback, useEffect, useState } from 'react';
import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { Alert, CssBaseline, Paper, Snackbar, Stack, Typography } from '@mui/material';
import PrivateRoute from './PrivateRoute';
import http from './commonFunctions/httpClient';
import DashboardLayout from './Components/Dashboard/DashboardLayout';
import config from './Config/config.json';
import { LoginForm } from './FrontEnd/Login/Login';
import Logout from './FrontEnd/Logout/LogOut';
import { Registration } from './FrontEnd/Masters/Registration/UserRegistration';
import EPrint from './FrontEnd/Estimation/Print';
import QPrint from './FrontEnd/Quatation/Print';
import OrderPrint from './FrontEnd/Orders/Print';
import useFCMToken from './Components/Notifications/Firbase/useFCMTokenWeb';
import useFCMListener from './Components/Notifications/Firbase/useFCMListenerWeb';
import DashboardOverview from './FrontEnd/Dashboard/Dashboard';
import EMartinPrint from './FrontEnd/Estimation/PrintMartin';
import QMartinPrint from './FrontEnd/Quatation/PrintMartin';
import ThanksLetter from './FrontEnd/Orders/ThanksLetter';
import PartPaymentPrint from './FrontEnd/Orders/PartPaymentPrint';
import InvPrint from './FrontEnd/Invoice/InvPrint';
import CustomerStatementPrint from './FrontEnd/Invoice/CustomerStatementPrint';
const SESSION_TIMEOUT = config.sessionTimeOut * 60 * 1000; // 15 minutes

const App: React.FC = () => {
  const [token, setToken] = useState<string | null>(localStorage.getItem('token'));
  const [lastActivity, setLastActivity] = useState<number>(Date.now());
  const fcmToken = useFCMToken();
  const notifications = useFCMListener();
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (token) {
      http.setAuthToken(token);
    }
  }, [token]);

  useEffect(() => {
    if (!token) return;

    const handleActivity = () => {
      setLastActivity(Date.now());
    };

    // Add event listeners for user activity
    window.addEventListener('mousemove', handleActivity);
    window.addEventListener('keydown', handleActivity);

    const checkTimeout = () => {
      if (Date.now() - lastActivity > SESSION_TIMEOUT) {
        handleLogout(); // Logout the user after inactivity
        window.location.reload();
      }
    };

    const intervalId = setInterval(checkTimeout, 1000); // Check for timeout every second

    return () => {
      clearInterval(intervalId);
      window.removeEventListener('mousemove', handleActivity);
      window.removeEventListener('keydown', handleActivity);
    };
  }, [lastActivity, token]);
  useEffect(() => {

    if (notifications.length > 0) {
      setOpen(true);
    }
  }, [notifications]);

  useEffect(() => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.register("/firebase-messaging-sw.js")
        .then((registration) => console.log("Service Worker Registered!", registration))
        .catch((error) => console.error("Service Worker Registration Failed!", error));
    }
  }, []);

  const handleLogin = (newToken: string) => {
    setToken(newToken);
    localStorage.setItem('token', newToken);
    http.setAuthToken(newToken);
  };

  const handleLogout = useCallback(() => {
    setToken(null);
    localStorage.removeItem('token');
    http.setAuthToken(null);
  }, []);
  const latestNotification = notifications[notifications.length - 1];
  return (
    <Router>
      <CssBaseline />
      {/* <Stack spacing={3} sx={{ padding: 3 }}>
      <Paper sx={{ padding: 3, textAlign: 'center' }}>
        <Typography variant="h4">FCM Web Notifications</Typography>
        <Typography variant="body1">Your Device Token:</Typography>
        <Typography
          variant="body2"
          sx={{
            wordWrap: 'break-word',
            whiteSpace: 'pre-wrap',
            fontSize: '12px',
            backgroundColor: '#f5f5f5',
            padding: '10px',
            borderRadius: '4px',
          }}
        >
          {fcmToken || 'Fetching token...'}
        </Typography>
      </Paper>
    </Stack> */}
      <Routes>
        <Route path="/" element={token ? <DashboardLayout /> : <Navigate to="/login" replace />}>
          <Route index element={token ? <DashboardOverview /> : <Navigate to="/login" />} />
          <Route path="/*" element={<PrivateRoute token={token} />} />
        </Route>
        <Route path="/login" element={token ? <Navigate to="/" replace /> : <LoginForm onLogin={handleLogin} />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/registration" element={<Registration />} />
        <Route path="/estimation/print/:id?" element={<EPrint />} />
        <Route path="/quatation/print/:id?" element={<QPrint />} />
        <Route path="/payment/thanks-letter/print/:id?" element={<ThanksLetter />} />
        <Route path="/estimation/mprint/:id?" element={<EMartinPrint />} />
        <Route path="/quatation/mprint/:id?" element={<QMartinPrint />} />
        <Route path="/order/print/:id?" element={<OrderPrint />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
        <Route path="/order/part-payment/print/:id?" element={<PartPaymentPrint />} />
        <Route path="/invoice/print/:id?" element={<InvPrint />} />
        <Route path="/statement/:id/print" element={<CustomerStatementPrint />} />

      </Routes>
      <Snackbar open={open} onClose={() => setOpen(false)}>
        <Alert onClose={() => setOpen(false)} severity="info" sx={{ width: '100%' }}>
          {latestNotification?.title} - {latestNotification?.body}
        </Alert>
      </Snackbar>
    </Router>
  );
};

export default App;
